module.exports = __webpack_public_path__ + "static/media/coliseu_porto_ageas_circo_2021_29.4d44c8c5.jpg";